import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";

function Worang() {
    return (
        <div className="right-icon worang">
            <AiFillCloseCircle />
        </div>
    );
}

export default Worang;